export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MijnAccount.vue?vue&type=template&id=470902a9&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/MijnAccount.vue?vue&type=template&id=470902a9&
// module id = 426
// module chunks = 0